import React, { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useTheme } from '../../context/ThemeContext';
import { useAuth } from '../../context/AuthContext';

const navItems = [
  { to: '/dashboard', icon: '⚡', label: 'Dashboard' },
  { to: '/workout', icon: '💪', label: 'Workout' },
  { to: '/muscles', icon: '🧍', label: 'Muscle Map' },
  { to: '/nutrition', icon: '🥗', label: 'Nutrition' },
  { to: '/weight', icon: '⚖️', label: 'Weight' },
  { to: '/medications', icon: '💊', label: 'Medications' },
  { to: '/health', icon: '❤️', label: 'Health' },
  { to: '/progress', icon: '📈', label: 'Progress' },
  { to: '/settings', icon: '⚙️', label: 'Settings' },
];

export default function Sidebar() {
  const { theme } = useTheme();
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [collapsed, setCollapsed] = useState(false);

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <aside style={{
      width: collapsed ? '70px' : '220px',
      minHeight: '100vh',
      background: theme.bgSecondary,
      borderRight: `1px solid ${theme.border}`,
      display: 'flex',
      flexDirection: 'column',
      padding: '1.5rem 0',
      transition: 'width 0.3s ease',
      position: 'sticky',
      top: 0,
      flexShrink: 0,
    }}>
      {/* Logo */}
      <div style={{ padding: '0 1.25rem 2rem', borderBottom: `1px solid ${theme.border}` }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
          <div style={{
            width: '36px', height: '36px', borderRadius: '8px', flexShrink: 0,
            background: `linear-gradient(135deg, ${theme.accent}, ${theme.success})`,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontSize: '1.2rem',
          }}>⚡</div>
          {!collapsed && (
            <span style={{
              fontFamily: "'Rajdhani', sans-serif",
              fontWeight: 700, fontSize: '1.2rem',
              letterSpacing: '1px', color: theme.text,
            }}>VITALFORGE</span>
          )}
        </div>
      </div>

      {/* Nav */}
      <nav style={{ flex: 1, padding: '1rem 0.75rem' }}>
        {navItems.map(item => (
          <NavLink
            key={item.to}
            to={item.to}
            style={({ isActive }) => ({
              display: 'flex', alignItems: 'center',
              gap: '0.75rem', padding: '0.7rem 0.75rem',
              borderRadius: '8px', marginBottom: '0.25rem',
              textDecoration: 'none', transition: 'all 0.2s ease',
              background: isActive ? `${theme.accent}22` : 'transparent',
              color: isActive ? theme.accent : theme.textSecondary,
              borderLeft: isActive ? `3px solid ${theme.accent}` : '3px solid transparent',
              fontFamily: "'Exo 2', sans-serif",
              fontWeight: isActive ? 600 : 400,
              fontSize: '0.9rem',
            })}
          >
            <span style={{ fontSize: '1.1rem', flexShrink: 0 }}>{item.icon}</span>
            {!collapsed && item.label}
          </NavLink>
        ))}
      </nav>

      {/* Bottom */}
      <div style={{ padding: '0 0.75rem', borderTop: `1px solid ${theme.border}`, paddingTop: '1rem' }}>
        {!collapsed && (
          <div style={{ padding: '0.5rem 0.75rem', marginBottom: '0.5rem' }}>
            <div style={{ fontSize: '0.8rem', color: theme.textSecondary }}>{user?.displayName || 'User'}</div>
            <div style={{ fontSize: '0.7rem', color: theme.textSecondary, opacity: 0.6 }}>{user?.email}</div>
          </div>
        )}
        <button onClick={handleLogout} style={{
          width: '100%', padding: '0.6rem 0.75rem',
          background: 'transparent', border: `1px solid ${theme.border}`,
          borderRadius: '8px', color: theme.textSecondary,
          cursor: 'pointer', fontFamily: "'Exo 2', sans-serif",
          fontSize: '0.85rem', display: 'flex', alignItems: 'center', gap: '0.5rem',
          transition: 'all 0.2s ease',
        }}
        onMouseEnter={e => { e.currentTarget.style.borderColor = theme.danger; e.currentTarget.style.color = theme.danger; }}
        onMouseLeave={e => { e.currentTarget.style.borderColor = theme.border; e.currentTarget.style.color = theme.textSecondary; }}
        >
          🚪 {!collapsed && 'Logout'}
        </button>
        <button onClick={() => setCollapsed(!collapsed)} style={{
          width: '100%', marginTop: '0.5rem', padding: '0.5rem',
          background: 'transparent', border: 'none',
          color: theme.textSecondary, cursor: 'pointer', fontSize: '0.8rem',
        }}>
          {collapsed ? '→' : '← Collapse'}
        </button>
      </div>
    </aside>
  );
}
